import { util } from 'pevueglobal'
import { router } from '../../router'
import {
  setXVtableMutations,
  XVTablesort,
  XVtablecolumnsettingchanged,
  initXVtableState,
  XVtableSetRowStateProperty,
  XVtableGetValue
} from '../XVtableV2'

// state
const state = {
  bestuurdersTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  bestuurdersActive: {
    toggle: true
  },
  bestuurder: {
    rbKredietbemiddeling: '',
    tbxNaam: '',
    tbxVoornaam: '',
    tbxInitialen: '',
    tbxRijksregisternummer: '',
    tbxOndernemingsnummer: '',
    tbxFunctie: '',
    rbAard: null,
    tbxVertegenwoordiger: '',
    tbxVertegenwoordigerRijksregnr: '',
    iDatumactief: null,
    iDatumInactief: null,
    tbaOpmerking: '',
    uploadfiles: []
  },
  bestuurderRijksNrVerplicht: false,
  bestuurderOndernNrVerplicht: false,

  aandeelhoudersActive: {
    toggle: true
  },
  aandeelhoudersTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  aandeelhouder: {
    tbxNaam: '',
    tbxVoornaam: '',
    tbxInitialen: '',
    tbxRijksregisternummer: '',
    tbxOndernemingsnummer: '',
    tbxAandelen: null,
    tbxStemrecht: null,
    rbAard: null,
    iDatumactief: null,
    iDatumInactief: null,
    tbaOpmerking: '',
    uploadfiles: []
  },
  aandeelhouderRijksNrVerplicht: false,
  aandeelhouderOndernNrVerplicht: false,
  myPersonData: []
}

// getters
const getters = {
  bestuurdersTable: state => state.bestuurdersTable,
  aandeelhoudersTable: state => state.aandeelhoudersTable,
  aandeelhouderRijksNrVerplicht: state => state.aandeelhouderRijksNrVerplicht,
  aandeelhouderOndernNrVerplicht: state => state.aandeelhouderOndernNrVerplicht,
  bestuurderRijksNrVerplicht: state => state.bestuurderRijksNrVerplicht,
  bestuurderOndernNrVerplicht: state => state.bestuurderOndernNrVerplicht,
  myPersonData: state => state.myPersonData
}

// actions
const actions = {
  getTextenAandeelhouders: async ({ dispatch }) => {
    let textIDs = [14929, 14933, 14934, 14977, 14981, 14984, 15187]
    for (var i = 14941; i <= 14957; i++) {
      textIDs.push(i)
    }
    dispatch('gettranslations', textIDs, { root: true })
  },
  getTextenBestuurders: async ({ dispatch }) => {
    let textIDs = [14642, 14981, 14984, 15175, 15188]
    for (var i = 14920; i <= 14942; i++) {
      textIDs.push(i)
    }
    dispatch('gettranslations', textIDs, { root: true })
  },
  getBestuurders: async ({ commit }, inputdata) => {
    if (inputdata) {
      const [persondata, BestuurderstabledataPersonID] = await Promise.all([
        util.getDataApi('allroles/PEapi_GetPersondata', {
          TableColumns: 'tblpersonname',
          MetaIds: null,
          tblpersonid: inputdata
        }),
        util.GetXVTableDataV2('allroles/PEapi_VMSWbeheerders_XVTableV2', { tblpersonid: inputdata })
      ])
      commit('setPersonData', persondata)
      commit('setBestuurdersTable', BestuurderstabledataPersonID)
      commit('setXVtableColumnSettingsBestuurders')
      commit('setBestuurdersXVtablesetting')
      commit('initXVtableState', state.bestuurdersTable, { tblpersonid: inputdata })
    } else {
      const [Bestuurderstabledata] = await Promise.all([
        util.GetXVTableDataV2('allroles/PEapi_VMSWbeheerders_XVTableV2', { tblpersonid: 0 })
      ])
      commit('setBestuurdersTable', Bestuurderstabledata)
      commit('setXVtableColumnSettingsBestuurders')
      commit('setBestuurdersXVtablesetting')
      commit('initXVtableState', state.bestuurdersTable)
    }
  },
  insertBestuurder: async ({ commit, rootState, dispatch }, inputdata) => {
    const output = await util.getDataApi('allroles/PEapi_VMSWbeheerders_insertV2', inputdata)
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )
      dispatch('getBestuurders')
      if (inputdata.tblpersonid) {
        router.push({ name: 'VMSWbestuurdersInzien', params: { personid: inputdata.tblpersonid } })
      } else {
        router.push({ name: 'VMSWbestuurders' })
      }
    }
  },
  updateBestuurder: async ({ commit, rootState, dispatch }, inputdata) => {
    const output = await util.getDataApi('allroles/PEapi_VMSWbeheerders_updateV2', inputdata)
    if (output.status === '200') {
      dispatch('getBestuurders')
      if (inputdata.tblpersonid) {
        router.push({ name: 'VMSWbestuurdersInzien', params: { personid: inputdata.tblpersonid } })
      } else {
        router.push({ name: 'VMSWbestuurders' })
      }
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )
    }
  },
  getAandeelhouders: async ({ commit }, inputdata) => {
    if (inputdata) {
      const [persondata, aandeelhouderstabledataPersonID] = await Promise.all([
        util.getDataApi('allroles/PEapi_GetPersondata', {
          TableColumns: 'tblpersonname',
          MetaIds: null,
          tblpersonid: inputdata
        }),
        util.GetXVTableDataV2('allroles/PEapi_VMSWaandeelhouders_XVTableV2', { tblpersonid: inputdata })
      ])
      commit('setPersonData', persondata)
      commit('setAandeelhoudersTable', aandeelhouderstabledataPersonID)
      commit('setXVtableColumnsettings')
      commit('setXVtablesetting')
      commit('AandeelhouderinitXVtableState', state.aandeelhoudersTable, { tblpersonid: inputdata })
    } else {
      const [aandeelhouderstabledata] = await Promise.all([
        util.GetXVTableDataV2('allroles/PEapi_VMSWaandeelhouders_XVTableV2')
      ])
      commit('setAandeelhoudersTable', aandeelhouderstabledata)
      commit('setXVtableColumnsettings')
      commit('setXVtablesetting')
      commit('AandeelhouderinitXVtableState', state.aandeelhoudersTable)
    }
  },
  insertAandeelhouder: async ({ commit, rootState, dispatch }, inputdata) => {
    const output = await util.getDataApi('allroles/PEapi_VMSWaandeelhouders_insertV2', inputdata)
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )
      dispatch('getAandeelhouders')
      if (inputdata.tblpersonid) {
        router.push({ name: 'VMSWaandeelhoudersInzien', params: { personid: inputdata.tblpersonid } })
      } else {
        router.push({ name: 'VMSWaandeelhouders' })
      }
    }
  },
  updateAandeelhouder: async ({ commit, rootState, dispatch }, inputdata) => {
    const output = await util.getDataApi('allroles/PEapi_VMSWaandeelhouders_updateV2', inputdata)
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )
      dispatch('getAandeelhouders')
      if (inputdata.tblpersonid) {
        router.push({ name: 'VMSWaandeelhoudersInzien', params: { personid: inputdata.tblpersonid } })
      } else {
        router.push({ name: 'VMSWaandeelhouders' })
      }
    }
  }
}

// mutations
const mutations = {
  ...setXVtableMutations('bestuurdersTable'),
  AandeelhouderXVtableGetValue: XVtableGetValue('aandeelhoudersTable'),
  AandeelhouderXVTablesort: XVTablesort('aandeelhoudersTable'),
  AandeelhouderXVtablecolumnsettingchanged: XVtablecolumnsettingchanged('aandeelhoudersTable'),
  AandeelhouderinitXVtableState: initXVtableState('aandeelhoudersTable'),
  AandeelhouderXVtableSetRowStateProperty: XVtableSetRowStateProperty('aandeelhoudersTable'),
  makeUpdateBestuurderDetail(state, bestuurderID) {
    let bestuurder = state.bestuurdersTable.tabledata.filter(data => {
      return data.tblVMSWBestuurderID === bestuurderID
    })[0]
    let uploadfiles = []
    if (bestuurder.tblVMSWBestuurderVerklaringFMSA !== null) {
      uploadfiles = [
        {
          uploadFileID: bestuurder.tblVMSWBestuurderVerklaringFMSA,
          error: false
        }
      ]
    }
    let datuminactief
    if (bestuurder.tblVMSWBestuurderDatumInactief === null) {
      datuminactief = null
    } else {
      datuminactief = new Date(bestuurder.tblVMSWBestuurderDatumInactief)
    }
    state.bestuurder = {
      rbKredietbemiddeling: bestuurder.tblVMSWBestuurderActiefKrediet,
      tbxNaam: bestuurder.tblVMSWBestuurderNaam,
      tbxVoornaam: bestuurder.tblVMSWBestuurderVoornaam,
      tbxInitialen: bestuurder.tblVMSWBestuurderAndereVoornamen,
      tbxRijksregisternummer: bestuurder.tblVMSWBestuurderRijksregisterNummer,
      tbxOndernemingsnummer: bestuurder.tblVMSWBestuurderOndernemingsnummer,
      tbxVertegenwoordigerRijksregnr: bestuurder.tblVMSWBestuurderVasteVertegenwoordigerRijksregisterNummer,
      tbxFunctie: bestuurder.tblVMSWBestuurderFunctie,
      rbAard: bestuurder.tblVMSWBestuurderAard,
      tbxVertegenwoordiger: bestuurder.tblVMSWBestuurderVasteVertegenwoordiger,
      iDatumactief: new Date(bestuurder.tblVMSWBestuurderDatumActief),
      iDatumInactief: datuminactief,
      tbaOpmerking: bestuurder.tblVMSWBestuurderOpmerking,
      uploadfiles: uploadfiles
    }
    if (bestuurder.tblVMSWBestuurderAard === 1) {
      state.bestuurderRijksNrVerplicht = true
      state.bestuurderOndernNrVerplicht = false
    } else {
      state.bestuurderRijksNrVerplicht = false
      state.bestuurderOndernNrVerplicht = true
    }
  },
  clearBestuurderDetail(state) {
    state.bestuurder = {
      rbKredietbemiddeling: '',
      tbxNaam: '',
      tbxVoornaam: '',
      tbxInitialen: '',
      tbxFunctie: '',
      rbAard: null,
      tbxVertegenwoordiger: '',
      iDatumactief: null,
      iDatumInactief: null,
      tbaOpmerking: '',
      uploadfiles: []
    }
    state.bestuurderRijksNrVerplicht = false
    state.bestuurderOndernNrVerplicht = false
  },
  makeUpdateAandeelhouderDetail(state, aandeelhouderid) {
    let aandeelhouder = state.aandeelhoudersTable.tabledata.filter(data => {
      return data.tblVMSWAandeelhouderID === aandeelhouderid
    })[0]
    let uploadfiles = []
    if (aandeelhouder.tblVMSWAandeelhouderVerklaringFMSA !== null) {
      uploadfiles = [{ uploadFileID: aandeelhouder.tblVMSWAandeelhouderVerklaringFMSA, error: false }]
    }
    let datuminactief
    if (aandeelhouder.tblVMSWAandeelhouderDatumInactief === null) {
      datuminactief = null
    } else {
      datuminactief = new Date(aandeelhouder.tblVMSWAandeelhouderDatumInactief)
    }
    state.aandeelhouder = {
      tbxNaam: aandeelhouder.tblVMSWAandeelhouderNaam,
      tbxVoornaam: aandeelhouder.tblVMSWAandeelhouderVoornaam,
      tbxInitialen: aandeelhouder.tblVMSWAandeelhouderAndereVoornamen,
      tbxRijksregisternummer: aandeelhouder.tblVMSWAandeelhouderRijksregisternummer,
      tbxOndernemingsnummer: aandeelhouder.tblVMSWAandeelhouderOndernemingsnummer,
      tbxAandelen: aandeelhouder.tblVMSWAandeelhouderAandelenPercentage,
      tbxStemrecht: aandeelhouder.tblVMSWAandeelhouderStemrechtPercentage,
      rbAard: aandeelhouder.tblVMSWAandeelhouderAard,
      iDatumactief: new Date(aandeelhouder.tblVMSWAandeelhouderDatumActief),
      iDatumInactief: datuminactief,
      tbaOpmerking: aandeelhouder.tblVMSWAandeelhouderOpmerking,
      uploadfiles: uploadfiles
    }
    if (aandeelhouder.tblVMSWAandeelhouderAard === 1) {
      state.aandeelhouderRijksNrVerplicht = true
      state.aandeelhouderOndernNrVerplicht = false
    } else {
      state.aandeelhouderRijksNrVerplicht = false
      state.aandeelhouderOndernNrVerplicht = true
    }
  },
  clearAandeelhouderDetail(state) {
    state.aandeelhouder = {
      tbxNaam: '',
      tbxVoornaam: '',
      tbxInitialen: '',
      tbxRijksregisternummer: '',
      tbxOndernemingsnummer: '',
      tbxAandelen: null,
      tbxStemrecht: null,
      rbAard: null,
      iDatumactief: null,
      iDatumInactief: null,
      tbaOpmerking: '',
      uploadfiles: []
    }
    state.aandeelhouderRijksNrVerplicht = false
    state.aandeelhouderOndernNrVerplicht = false
  },
  toggleAandeelhouderAard(state) {
    if (state.aandeelhouder.rbAard === 1) {
      state.aandeelhouder.tbxOndernemingsnummer = ''
      state.aandeelhouderRijksNrVerplicht = true
      state.aandeelhouderOndernNrVerplicht = false
    } else {
      state.aandeelhouder.tbxRijksregisternummer = ''
      state.aandeelhouder.tbxInitialen = ''
      state.aandeelhouder.tbxVoornaam = ''
      state.aandeelhouderRijksNrVerplicht = false
      state.aandeelhouderOndernNrVerplicht = true
    }
  },
  toggleBestuurderAard(state) {
    if (state.bestuurder.rbAard === 1) {
      state.bestuurder.tbxOndernemingsnummer = ''
      state.bestuurder.tbxVertegenwoordiger = ''
      state.bestuurder.tbxVertegenwoordigerRijksregnr = ''
      state.bestuurderRijksNrVerplicht = true
      state.bestuurderOndernNrVerplicht = false
    } else {
      state.bestuurder.tbxRijksregisternummer = ''
      state.bestuurder.tbxInitialen = ''
      state.bestuurder.tbxVoornaam = ''
      state.bestuurderRijksNrVerplicht = false
      state.bestuurderOndernNrVerplicht = true
    }
  },
  setPersonData(state, myPersonData) {
    state.myPersonData = myPersonData.ds.data0[0].value
  },
  setAandeelhoudersTable(state, data) {
    state.aandeelhoudersTable.tabledata = data.tabledata
  },
  setXVtablesetting(state) {
    state.aandeelhoudersTable.tablesetting = {
      alwaysShowDetail: null,
      tableName: 'aandeelhouders',
      paging: 1,
      pagingSize: 50,
      procedure: 'PEapi_VMSWaandeelhouders_XVTable',
      sequence: 1,
      sortable: 1
    }
  },
  setXVtableColumnsettings(state) {
    state.aandeelhoudersTable.tablecolumnsetting = [
      {
        columnname: 'Naam',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderNaam',
        headerTextID: 14943,
        sequence: 1,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 1,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'Voornaam',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderVoornaam',
        headerTextID: 14944,
        sequence: 2,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'Andere Voornamen of Initialen',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderAndereVoornamen',
        headerTextID: 14945,
        sequence: 3,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'RijksregisterNummer',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderRijksregisternummer',
        headerTextID: 14982,
        sequence: 4,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'Ondernemingsnummer',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderOndernemingsnummer',
        headerTextID: 14983,
        sequence: 5,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'Aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'Aandelen % ',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderAandelenPercentage',
        headerTextID: 14947,
        sequence: 6,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'decimal',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'Stemrecht % ',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderStemrechtPercentage',
        headerTextID: 14948,
        sequence: 7,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'decimal',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'Aard',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderAard',
        headerTextID: 14946,
        sequence: 8,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'number',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'Datum actief',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderDatumActief',
        headerTextID: 14949,
        sequence: 9,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'date',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'Datum inactief',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderDatumInactief',
        headerTextID: 14950,
        sequence: 10,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'date',
        visible: 0,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'Opmerking',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderOpmerking',
        headerTextID: 14951,
        sequence: 11,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'Verklaring',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderVerklaringFMSA',
        headerTextID: 14952,
        sequence: 12,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'Text not defined',
        helpTextID: null,
        name: 'tblVMSWAandeelhouderID',
        headerTextID: null,
        sequence: 13,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'number',
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhouders',
        procedure: 'PEapi_VMSWaandeelhouders_XVTable'
      },
      {
        columnname: 'tableRowState',
        helpTextID: null,
        name: 'tableRowState',
        headerTextID: null,
        sequence: 14,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: null,
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'aandeelhoudersTable',
        procedure: ''
      }
    ]
  },
  setBestuurdersTable(state, data) {
    state.bestuurdersTable.tabledata = data.tabledata
  },
  setBestuurdersXVtablesetting(state) {
    state.bestuurdersTable.tablesetting = {
      alwaysShowDetail: null,
      tableName: 'bestuurders',
      paging: 1,
      pagingSize: 50,
      procedure: 'PEapi_VMSWbeheerders_XVtable',
      sequence: 1,
      sortable: 1
    }
  },
  setXVtableColumnSettingsBestuurders(state) {
    state.bestuurdersTable.tablecolumnsetting = [
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderNaam',
        sequence: 1,
        sortable: 1,
        sortableDefault: 1,
        visible: 1,
        columnnameTextID: 14920,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Naam'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderVoornaam',
        sequence: 2,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        columnnameTextID: 14921,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Voornaam'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderAndereVoornamen',
        sequence: 3,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        columnnameTextID: 14922,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Andere Voornamen of Initialen'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderRijksregisterNummer',
        sequence: 4,
        sortable: 0,
        sortableDefault: 0,
        visible: 1,
        columnnameTextID: 14980,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 0,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'RijksregisterNummer'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderOndernemingsnummer',
        sequence: 5,
        sortable: 0,
        sortableDefault: 0,
        visible: 1,
        columnnameTextID: 14981,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 0,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Ondernemingsnummer'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderFunctie',
        sequence: 6,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        columnnameTextID: 14923,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Functietitel binnen onderneming'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderActiefKrediet',
        sequence: 7,
        sortable: 0,
        sortableDefault: 0,
        visible: 1,
        columnnameTextID: 14924,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Actief in kredietbemiddeling'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderAard',
        sequence: 8,
        sortable: 0,
        sortableDefault: 0,
        visible: 1,
        columnnameTextID: 14925,
        visibleXS: 0,
        visibleSM: 1,
        visibleMD: 1,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Aard'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderVasteVertegenwoordiger',
        sequence: 9,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        columnnameTextID: 14926,
        visibleXS: 0,
        visibleSM: 1,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Vertegenwoordiger'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderDatumActief',
        sequence: 10,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        columnnameTextID: 14927,
        visibleXS: 0,
        visibleSM: 1,
        visibleMD: 1,
        type: 'date',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Datum actief'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderDatumInactief',
        sequence: 11,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        columnnameTextID: 14928,
        visibleXS: 0,
        visibleSM: 1,
        visibleMD: 1,
        type: 'date',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Datum inactief'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderOpmerking',
        sequence: 12,
        sortable: 0,
        sortableDefault: 0,
        visible: 1,
        columnnameTextID: 14929,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Opmerking'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderVerklaringFMSA',
        sequence: 13,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        columnnameTextID: 14930,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Verklaring'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderID',
        sequence: 14,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        columnnameTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined'
      },
      {
        procedure: 'PEapi_VMSWbeheerders_XVtable',
        tableName: 'bestuurders',
        name: 'tblVMSWBestuurderVasteVertegenwoordigerRijksregisterNummer',
        sequence: 15,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        columnnameTextID: 15175,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 0,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Rijksregisternummer van vertegenwoordiger'
      },
      {
        name: 'tableRowState',
        columnname: 'tableRowState',
        columnnameTextID: null,
        sequence: 16,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: null,
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'bestuurdersTable',
        procedure: '',
        helpTextID: null
      }
    ]
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
